/* eslint-disable jsx-a11y/label-has-associated-control */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import {
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  CustomInput,
} from 'reactstrap';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import * as masks from '@src/utility/Mask';

import InputPasswordToggle from '@components/input-password-toggle';
import { Loading } from '@src/@core/components/loading';
import { useBrand } from '@hooks/useBrand';
import { Controller } from 'react-hook-form';
import logo from '@src/assets/images/logo/logo.png';

import { useRegisterForm } from './useRegisterForm';

import '@styles/base/pages/page-auth.scss';

const RegisterForm: React.FC = () => {
  const { brand, nameTab } = useBrand();
  const [blocking, setBlocking] = useState(false);

  async function getIp() {
    try {
      const response = await axios.get('https://api.ipify.org?format=json');
      return response.data;
    } catch (error) {
      console.error(error, 'Could not identify IP');
    }
  }

  function handleChangeBlocking(isBlocking: boolean): void {
    setBlocking(isBlocking);
  }

  const { register, onSubmit, errors, control } = useRegisterForm({
    onChangeBlocking: handleChangeBlocking,
  });

  const Terms = () => {
    return (
      <>
        Eu aceito os
        <a
          className="ml-25"
          href={`${process.env.PUBLIC_URL}/contract/service`}
          target="_blank"
        >
          Termos de uso
        </a>
      </>
    );
  };

  const TermsPrivacy = () => {
    return (
      <>
        Eu aceito os
        <a
          className="ml-25"
          href={`${process.env.REACT_APP_UPLOADS}/contract/termsOfPrivacy/Ultragate-Politica-de-Privacidade.pdf`}
          target="_blank"
        >
          Termos de Política de Privacidade
        </a>
      </>
    );
  };

  useEffect(() => {
    document.title = `Cadastro | ${nameTab}`;
  }, [nameTab]);

  return (
    <>
      <div className="auth-wrapper auth-v1 px-2">
        <div className="auth-inner py-2">
          <Card className="mb-0">
            <CardBody>
              <Link
                className="brand-logo"
                to="/"
                onClick={(e) => e.preventDefault()}
              >
                {nameTab.toLowerCase() !== 'ultrapayments' ? (
                  <img
                    src={brand}
                    alt="Logo Ultrapayments"
                    className="img-fluid"
                    style={{ width: '189px' }}
                  />
                ) : (
                  <img
                    src={logo}
                    alt="Logo Ultrapayments"
                    className="img-fluid"
                  />
                )}
              </Link>
              <CardTitle tag="h4" className="mb-1">
                Crie sua conta 🚀
              </CardTitle>
              <Form className="auth-register-form mt-2" onSubmit={onSubmit}>
                <FormGroup>
                  <Label className="form-label" for="name">
                    Nome completo
                  </Label>
                  <Input
                    autoFocus
                    type="text"
                    id="name"
                    name="name"
                    placeholder="johndoe"
                    className={classnames({
                      'is-invalid': errors.name,
                    })}
                    innerRef={register({ required: true })}
                  />
                  {errors && errors.name && (
                    <FormFeedback>{errors.name.message}</FormFeedback>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label className="form-label" for="email">
                    Email
                  </Label>
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="john@example.com"
                    className={classnames({
                      'is-invalid': errors.email,
                    })}
                    innerRef={register({ required: true })}
                  />
                  {errors && errors.email && (
                    <FormFeedback>{errors.email.message}</FormFeedback>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label className="form-label" for="mobile">
                    Celular
                  </Label>
                  <Input
                    type="tel"
                    name="mobile"
                    id="mobile"
                    placeholder="(99) 99999-9999"
                    innerRef={register({ required: true })}
                    onChange={masks.phoneMask.onChange}
                    className={classnames({
                      'is-invalid': errors.mobile,
                    })}
                  />
                  {errors && errors.mobile && (
                    <FormFeedback>{errors.mobile.message}</FormFeedback>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label className="form-label" for="password">
                    Senha
                  </Label>
                  <InputPasswordToggle
                    id="password"
                    name="password"
                    className={`input-group-merge ${classnames({
                      'is-invalid': errors.password,
                    })}`}
                    innerRef={register({ required: true })}
                  />
                  {errors && errors.password && (
                    <FormFeedback>{errors.password.message}</FormFeedback>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label className="form-label" for="password_confirmation">
                    Confirme sua senha
                  </Label>
                  <InputPasswordToggle
                    id="password_confirmation"
                    name="password_confirmation"
                    className={`input-group-merge ${classnames({
                      'is-invalid': errors.password_confirmation,
                    })}`}
                    innerRef={register({ required: true })}
                  />
                  {errors && errors.password_confirmation && (
                    <FormFeedback>
                      {errors.password_confirmation.message}
                    </FormFeedback>
                  )}
                </FormGroup>
                <FormGroup>
                  <Controller
                    name="terms_of_use"
                    control={control}
                    rules={{ required: true }}
                    defaultValue={false}
                    render={({ onChange, value, name }) => {
                      return (
                        <CustomInput
                          type="checkbox"
                          label={<Terms />}
                          className="custom-control-Primary"
                          id="terms_of_use"
                          name={name}
                          onChange={(e) => onChange(e.target.checked)}
                          checked={value}
                          invalid={errors.terms_of_use && true}
                        />
                      );
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <Controller
                    name="terms_of_privacity"
                    control={control}
                    rules={{ required: true }}
                    defaultValue={false}
                    render={({ onChange, value, name }) => {
                      return (
                        <CustomInput
                          type="checkbox"
                          label={<TermsPrivacy />}
                          className="custom-control-Primary"
                          id="terms_of_privacity"
                          name={name}
                          onChange={(e) => onChange(e.target.checked)}
                          checked={value}
                          invalid={errors.terms_of_privacity && true}
                        />
                      );
                    }}
                  />
                </FormGroup>
                <Button type="submit" color="primary" block>
                  Cadastrar
                </Button>
              </Form>
              <p className="text-center mt-2">
                <span className="mr-25">Já tem conta?</span>
                <Link to="/login">
                  <span>Faça seu login</span>
                </Link>
              </p>
            </CardBody>
          </Card>
        </div>
      </div>

      <Loading blocking={blocking} />
    </>
  );
};

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_API_RECAPTCHA_SITE_KEY!;

export const Register: React.FC = () => (
  <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
    <RegisterForm />
  </GoogleReCaptchaProvider>
);
